

































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import Activities from '@/components/Activities.vue'; // @ is an alias to /src
import RegisterActivity from '@/components/RegisterActivity.vue';
import moment from 'moment';
import { db, userData } from '../main';
const _ = require('lodash');

Vue.component('RegisterActivity', RegisterActivity);

@Component
export default class Home extends Vue {
  public chartType = 'points';
  public current = 1;
  public showAllLaps = false;

  public data() {
    return {
      name: userData.user.name,
      challenge: userData.challenge,
      userData
    };
  }

  get userStats() {
    const stats = userData.statsData.userStats.filter((s: any) => s.totalPoints > 0);
    stats.sort((a: any, b: any) => this.chartType === 'points' ? b.totalPoints - a.totalPoints : (this.chartType === 'kcal' ? b.totalKcal - a.totalKcal : b.totalTime - a.totalTime));
    return stats;
  }

  get total() {
    if (userData.statsData.userStats.length < 1)
      return { kcal: 0, minutes: 0 };
    const totMinutes = userData.statsData.userStats.map((x: any) => x.totalTime).reduce((a: any, b: any) => a + b, 0);
    const totKcal = userData.statsData.userStats.map((x: any) => x.totalKcal).reduce((a: any, b: any) => a + b, 0);
    return { kcal: totKcal, minutes: totMinutes };
  }

  get max() {
    if (userData.statsData.userStats.length < 1)
      return 1;
    const max = userData.statsData.userStats.map((x: any) => this.chartType === 'points' ? x.totalPoints
      : this.chartType === 'kcal' ? x.totalKcal : x.totalTime).reduce((a: any, b: any) => {
        return Math.max(a, b);
    }, 0);
    return max > 0 ? max : 1;
  }

  get filteredActivities() {
    return userData.activities.map(x =>  ({ text: x.text, id: x.id })).filter(x =>
      userData.runOnly ? x.text.indexOf('Löpning') === 0
      : (userData.cycleOnly ? x.text.toLowerCase().indexOf('cykling') !== -1
      : (userData.miscOnly ? x.text.indexOf('Löpning') === -1 && x.text.toLowerCase().indexOf('cykling') === -1
      : false)));
  }

  get latestEntries() {
    const entries = userData.statsData.allEntries;
    entries.sort((a: any, b: any) => b.created - a.created);
    return entries.slice((this.current - 1) * 20, 20 + (this.current - 1) * 20);
  }

  public minuteHour(entry: any) {
    return entry.minutes < 100 ? entry.minutes : (entry.minutes / 60).toFixed(1);
  }

  public minuteHourTitle(entry: any) {
    return entry.minutes < 100 ? 'min' : 'tim';
  }

  public elipsedLink(link: string) {
    const maxLength = 32;
    let shortened = link.replace('http://','').replace('https://','').replace('www.', '');
    if(shortened.length > maxLength)
      return shortened.substring(0, maxLength) + '...';
    return shortened;
  }

  public comment(entry: any) {
    this.$dialog.prompt({
        message: 'Skriv din kommentar',
        inputAttrs: {
            placeholder: '',
            maxlength: 200,
        },
        confirmText: 'Skicka',
        cancelText: 'Avbryt',
        onConfirm: (comment) => {
          userData.saveComment(comment, entry);
        }
    });
  }

  public getPointColor(points: number)
  {
    const hsl = 'hsl(0, 0%, @value%)';
    const percent = points / 600;
    const value = 90 - (90 * percent);
    return { color: hsl.replace('@value', value.toString()) };
  }

  public toggleAllLaps() {
    this.showAllLaps = !this.showAllLaps;
  }

  public async mounted() {
    const invitecid = this.$route.query['i'] as string;
    if(!invitecid)
      return;

    if(userData.user.challenges.find(x => x === invitecid))
      return;
      
    const challenges = await userData.loadChallenges();
    const challenge = challenges.find(x => x.id === invitecid);
    if(!challenge)
      return;

    this.$dialog.confirm({
      title: 'Du har fått en inbjudan!',
      message: '<b>' + challenge.name + '</b><br> ' + challenge.description + '<br><br>' 
      + 'Skapad av: <b>' + userData.getUserName(challenge.uid) + '</b><br>'  
      + 'Från: <b>' +  moment(challenge.startdate).format('LLL') + '</b><br>' 
      + 'Till: <b>' + moment(challenge.enddate).format('LLL') + '</b><br>'
      + 'Status: <b>' + (challenge.status() == 'ended' ? 'Avslutad' : (challenge.status() == 'started' ? 'Påbörjad' : 'Ej startad')) + '</b><br>'  
      + '<br>Vill du vara med?',
      cancelText: 'Nej tack',
      confirmText: 'Självklart!',
      type: 'is-success',
      onConfirm: () => {
        userData.user.default_challenge = invitecid;
        userData.user.challenges.push(invitecid);
        userData.saveUser().then(() => {  
          userData.loadUser(userData.user);
          this.$toast.open('Du är nu med. Lyck till!');
        })
      }
    });
    this.$router.push('home')
  }

  // --------------
    tabledata = <any>[];
    columns = [
        {
            field: 'week',
            label: 'Vecka',
            width: '40',
            renderHtml: true,
            centered: true
        },
        {
            field: 'w',
            label: 'Vinnare totalt',
            renderHtml: true
        },
        {
            field: 'wkcal',
            label: 'Kcal',
            renderHtml: true  
        },
        {
            field: 'wminutes',
            label: 'Minuter',
            renderHtml: true
        },
        {
            field: 'wnumberofacts',
            label: 'Antal aktiviteter',
            renderHtml: true
        },
        {
            field: 'winnervariation',
            label: 'Störst variation',
            renderHtml: true
        }
    ]
  //  ------------

  // @Watch('filteredActivities')
  public filterPressed(value: any) {
    this.current = 1;
    userData.loadStats({activities: value.map((x: any) => x.id)});
  }

  @Watch('userData.challenge')
  public callangeChange() {
    userData.loadStats();
  }
}
